// @flow

import React from 'react';
import bemify from 'bemify-js';

import SimplePromo from 'app/login/components/SimplePromo';
import 'app/login/components/PlatformLogin/PlatformLogin.scss';

import type { SimplePromoProps } from 'app/login/components/SimplePromo';

const bem = bemify('platform-login');

const PlatformLogin = (props: SimplePromoProps) => (
  <SimplePromo {...props} className={bem()} title="Log in to Zapier">
    <div className={bem('__description')}>
      Log in to your Zapier account to manage your integration(s), view
      performance data, and collaborate with your team.
    </div>
  </SimplePromo>
);

export default PlatformLogin;
